import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDLabelText } from '@facet-wealth/design';

export const BillingDetailsMobileRowLineItemMetaOverride = buildFacetDesignOverride()
  .nameOverride(['description'], {
    _component: () => FDLabelText,
  }, overrideReadOnly)
  .nameOverride(['subTotal', 'paymentMethod'], {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly);
